export enum GeneralStocksState {
  ZERO = 'zero',
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
}
